import { Box, FormControl, Grid, TextField, Typography } from '@mui/material';
import { DesktopDatePicker, jaJP, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { datePickerConst } from '../../const/commonConst';
import { DateType } from '../../utils/dateHandler';

import theme from '../../../theme';

type PropsType = {
	startDate: DateType | null;
	endDate: DateType | null;
	handleChangeStartDate: (newValue: DateType | null) => void;
	handleChangeEndDate: (newValue: DateType | null) => void;
};

/**
 * 検索期間選択ボックス
 */
export const SearchPeriod = (props: PropsType) => {
	const { startDate, endDate, handleChangeStartDate, handleChangeEndDate } = props;

	return (
		<FormControl>
			<Grid container direction="row" justifyContent="space-between" alignItems="center">
				<Grid item xs={5}>
					<Box position="relative" left="12px">
						<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={jaJP} dateFormats={{ monthAndYear: datePickerConst.monthAndYear }}>
							<DesktopDatePicker
								className="startDate"
								label={<Typography sx={{ fontSize: 15, color: theme.palette.common.black }}>{datePickerConst.startDateLabel}</Typography>}
								value={startDate}
								onChange={handleChangeStartDate}
								inputFormat={datePickerConst.inputFormat}
								mask={datePickerConst.mask}
								renderInput={(params) => <TextField {...params} size="small" sx={{ flexGrow: 1, display: 'flex' }} />}
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
				<Grid item xs={2}>
					<Typography role="lable" aria-label={datePickerConst.centerLabel} align="center" sx={{ fontSize: 16, color: theme.palette.common.black }}>
						{datePickerConst.centerLabel}
					</Typography>
				</Grid>
				<Grid item xs={5}>
					<Box position="relative" right="12px">
						<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={jaJP} dateFormats={{ monthAndYear: datePickerConst.monthAndYear }}>
							<DesktopDatePicker
								className="endDate"
								label={<Typography sx={{ fontSize: 15, color: theme.palette.common.black }}>{datePickerConst.endDateLabel}</Typography>}
								value={endDate}
								onChange={handleChangeEndDate}
								inputFormat={datePickerConst.inputFormat}
								mask={datePickerConst.mask}
								renderInput={(params) => <TextField {...params} size="small" sx={{ flexGrow: 1, display: 'flex' }} />}
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
			</Grid>
		</FormControl>
	);
};
